export const subRoles = [
  { name: "Hourly", id: 1 },
  { name: "Salary", id: 2 },
];

export const getSubRoles = (subRolesId: number) => {
  const sub = subRoles.find(item => item.id === subRolesId);
  return sub?.id;
};
